export default __webpack_public_path__ + "static/media/images.e51d426d.svg";